module.exports = __webpack_public_path__ + "img/tc.tcc817f55.svg";